import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { emailFormInitialValues } from 'components/organisms/forms/email/EmailForm';
import { FormikHelpers } from 'formik';
import { useMutateOptions } from 'hooks';
import { useTranslation } from 'react-i18next';
import { PiX } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { usePostEmail } from 'services/email/email';
import { ICreateEmail } from 'services/email/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const CreateEmail = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const createEmail = usePostEmail();
  const mutateOptions = useMutateOptions<ICreateEmail>();

  const onGoToDetail = (id: string) => navigate(`/settings/email/${id}`);

  const onCreateSale = async (
    values: ICreateEmail,
    helpers: FormikHelpers<ICreateEmail>
  ) => {
    await createEmail.mutateAsync(values, {
      ...mutateOptions(helpers),
      onSuccess: ({ id }: any) => onGoToDetail(id.value),
    });
  };

  return (
    <Form.Email
      onSubmit={onCreateSale}
      backPath='/settings/emails'
      tittle={t('email.create-sales')}
      initialValues={emailFormInitialValues}
      customBackItem={
        <Button
          type='button'
          onlyIcon
          onClick={() => navigate('/settings/email')}>
          <Button.Description description={t('button.cancel')} />

          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <Button type='submit' variant={BUTTON_VARIANT.submit}>
          <Button.Text text={t('button.add')} />
        </Button>
      }
    />
  );
};

export default CreateEmail;
